import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { Notification } from '@/components/Notification/Notification';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import AlertIcon from '@/images/AlertIcon.svg?react';
import { IconWrapper } from './styles';

type SubscriptionCancelledNotificationType = {
  isLoading: boolean;
  onReactiveSubscription: () => void;
};

export const SubscriptionCancelledNotification = ({
  isLoading,
  onReactiveSubscription,
}: SubscriptionCancelledNotificationType) => {
  return (
    <Notification
      variant='info-tertiary'
      icon={
        <IconWrapper backgroundColor={COLORS.red[100]}>
          <AlertIcon />
        </IconWrapper>
      }
    >
      <Box width='100%' display='flex' alignItems='center' justifyContent='space-between' columnGap='20px'>
        <Box display='flex' flexDirection='column'>
          <Typography color={COLORS.grey[950]} fontWeight='semibold'>
            Your subscription has been cancelled.
          </Typography>
          <Typography color={COLORS.grey[700]} variant='bodySmall'>
            Your organization`s subscription was cancelled. All Admins now have <b>view-only access</b> and can no
            longer use premium features. You can <b>reactivate</b> your subscription at any time by choosing a new plan.
            Please note: switching to a lower-tier plan may limit available features, including the number of Admins who
            can actively work in your organization.
          </Typography>
        </Box>
        <Box display='flex' flexShrink={0}>
          <Button width='200px' size='medium' onClick={onReactiveSubscription} isLoading={isLoading}>
            Reactivate Subscription
          </Button>
        </Box>
      </Box>
    </Notification>
  );
};
